import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { CustomQuestionsState, RootState } from '../types';

const namespaced: boolean = true;

export const state: CustomQuestionsState = {
	questions: [],
	customFields: [],
	customFieldsInitialized: false
};

export const CustomQuestions: Module<CustomQuestionsState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default CustomQuestions;
